module.exports = __webpack_public_path__ + "static/media/DuoVitLogo2.c649150a.svg";